import { reduxForm } from 'redux-form';
import Component from './Component';

const initialValues = {
  period: [null, null],
  reasonId: '',
  reasonDetailId: '',
  agree: false,
  file: null,
};

const FormBlockedNik = reduxForm({
  form: 'FormBlockedNik',
  initialValues,
  enableReinitialize: true,
})(Component);

export default FormBlockedNik;
